import React from 'react';

import { Container, Step, Track } from './_stepper';

interface IStep {
  step: number;
  activeImage: string;
  inactiveImage: string;
}

interface IStepper {
  steps: IStep[];
  setSteps: Function;
  currentStep: number;
  inactiveColor: string;
  activeColor: string;
}

export const Stepper: React.FC<IStepper> = (
  { steps, currentStep, inactiveColor, activeColor, setSteps },
  index,
) => {

  const stepsHandler = [
    0,
    1,
    1.1
  ]

  const renderCoins = () => {
    return steps.map(({ activeImage, inactiveImage }, index) => {
      return (
        <Step
          className="step"
          key={index}
          border={currentStep >= index ? activeColor : inactiveColor}
          image={currentStep >= index ? activeImage : inactiveImage}
          onClick={() => setSteps(stepsHandler[index])}
        >
          <div className="step__coin" key={index} />

          {renderTrack(index)}
        </Step>
      );
    });
  };

  const renderTrack = (index: number) => {
    if (index >= 0 && index < steps.length - 1) {
      return (
        <Track
          key={`track-${index}`}
          className="track"
          border={currentStep >= index ? activeColor : inactiveColor}
        />
      );
    }
  };

  return <Container className="stepper">{renderCoins()}</Container>;
};
